var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5312 18.7969H17.3125V8.29688C17.3125 4.81714 14.7849 2.36993 10.9375 2.01361V0.9375C10.9375 0.419678 10.5178 0 10 0C9.48218 0 9.0625 0.419678 9.0625 0.9375V2.01361C5.21509 2.36993 2.6875 4.81714 2.6875 8.29688V18.7969H1.46875C0.950928 18.7969 0.53125 19.2166 0.53125 19.7344C0.53125 20.2522 0.950928 20.6719 1.46875 20.6719H7.53357C7.46124 20.9094 7.42188 21.1611 7.42188 21.4219C7.42188 22.8435 8.57837 24 10 24C11.4216 24 12.5781 22.8435 12.5781 21.4219C12.5781 21.1611 12.5388 20.9094 12.4664 20.6719H18.5312C19.0491 20.6719 19.4688 20.2522 19.4688 19.7344C19.4688 19.2166 19.0491 18.7969 18.5312 18.7969ZM10 22.125C9.61237 22.125 9.29688 21.8095 9.29688 21.4219C9.29688 21.0342 9.61237 20.7188 10 20.7188C10.3876 20.7188 10.7031 21.0342 10.7031 21.4219C10.7031 21.8095 10.3876 22.125 10 22.125ZM4.5625 17.0156H12.625C13.1428 17.0156 13.5625 16.5959 13.5625 16.0781C13.5625 15.5603 13.1428 15.1406 12.625 15.1406H4.5625V8.29688C4.5625 5.06964 7.32886 3.88092 9.92017 3.8443H10.0798C12.6711 3.88092 15.4375 5.06964 15.4375 8.29688V18.7969H4.5625V17.0156Z",
    fill: "url(#paint0_linear_3866_280)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3866_280",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#522F91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.6dac9a38081c5ecd0e59a096d5c5c3ea.svg";
export { ForwardRef as ReactComponent };